// @flow
import { buildProductArgs } from 'Utils/graphql';
import gqlClient from 'Utils/graphql-client/graphqlClient';
import { STATE_PRODUCT_PRICE_TICKET } from 'Utils/request/requestDictionary';

import { QUERY_DEPARTURE_DATE, QUERY_DURATION, QUERY_TRANSPORT } from 'Utils/uri/constants';
import { url as urlUtils } from '@clubmed/utils';

function fetchPrice(
  appContext: AppContext,
  location: ProductRouterLocation,
  productId: string,
): Promise<PriceTicketRequestActionPayload> {
  const { urlParams, queryParams } = location;
  const offerName = urlUtils.decodePath(queryParams.offer) || '';
  const duration = queryParams[QUERY_DURATION];
  const productArgsToBuild = {};

  productArgsToBuild.offerName = offerName;
  productArgsToBuild.date = queryParams[QUERY_DEPARTURE_DATE] || '';
  productArgsToBuild.departureCity = queryParams[QUERY_TRANSPORT] || '';

  if (duration) {
    productArgsToBuild.duration = parseInt(duration, 10);
  }

  const { cmsContent = '', cmsRelease = '' } = appContext;
  const productArgs = buildProductArgs(productId, urlParams, productArgsToBuild);

  const cmsArgs = `content: "${cmsContent}", release: "${cmsRelease}"`;

  const query = `query {
    price(${productArgs}) {
      offerColor( offerName : "${offerName}")
      bestPrice {
        value
        formattedValue
      }
      initialPrice {
        value
        formattedValue
      }
      unit(${cmsArgs})
      currency
      termsAndConditions {
        departureDate
        duration
        durationFormatted(${cmsArgs})
        departureCity {
          value
          name
        }
        numberOfAdults
        accommodationComfortLabel
      }
    }
  }`;

  return gqlClient.runQuery(query, appContext, { requestName: STATE_PRODUCT_PRICE_TICKET });
}

export { fetchPrice };
